import googleAnalytics from './googleAnalytics'
import googleTagManager from './googleTagManager'
import metaConversionApi from './metaConversionApi'
import MicrosoftAds from './microsoftAds'
import pixelAnalytics from './pixelAnalytics'

let global_config
let global_router
let eventSenders = []

async function load(config, router, store) {
  global_config = config
  global_router = router
  let cookies = localStorage.getItem('cookies-configuration')
  if (!cookies) cookies = { essential: true, analysis: false, advertising: false }
  else cookies = JSON.parse(cookies)
  if (!config) return
  if (config.googleAnalyticsId) {
    await googleAnalytics.load(config.googleAnalyticsId, cookies, config.domains)
    eventSenders.push(googleAnalytics)
  }
  if (config.facebookAnalyticsId) {
    await pixelAnalytics.load(config.facebookAnalyticsId, router)
    eventSenders.push(pixelAnalytics)
    if (config.metaConversionApiToken) {
      eventSenders.push(
        new metaConversionApi(
          config.facebookAnalyticsId,
          config.metaConversionApiToken,
          router,
          store
        )
      )
    }
  }
  if (config.googleTagManagerId) {
    await googleTagManager.load(config.googleTagManagerId, cookies)
    eventSenders.push(googleTagManager)
  }
  if (config.microsoftAdsId) {
    eventSenders.push(new MicrosoftAds(config.microsoftAdsId))
  }
}

async function reload(userGetter) {
  load(global_config, global_router, userGetter)
}

async function sendCheckoutCompleted(
  orderId,
  locationName,
  products,
  totalPrice,
  deliveryFee,
  taxRate,
  currencyCode,
  promotionCode
) {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.checkoutCompleted)
    .forEach(sender => {
      sender.checkoutCompleted({
        orderId,
        locationName,
        products,
        totalPrice,
        deliveryFee,
        taxRate,
        currencyCode,
        promotionCode
      })
    })
}

async function sendProductAddedToCart(product, currencyCode) {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.addProductToCart)
    .forEach(sender => {
      sender.addProductToCart({
        product,
        currencyCode
      })
    })
}

async function sendProductRemovedFromCart(product) {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.removeProductFromCart)
    .forEach(sender => {
      sender.removeProductFromCart({
        product
      })
    })
}

async function sendUserLoggedIn() {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.userLoggedIn)
    .forEach(sender => {
      sender.userLoggedIn()
    })
}

async function sendBeginCheckout(products, totalPrice, currencyCode, promotionCode) {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.beginCheckout)
    .forEach(sender => {
      sender.beginCheckout({
        products,
        totalPrice,
        currencyCode,
        promotionCode
      })
    })
}

async function sendUserSignedUp() {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.userSignedUp)
    .forEach(sender => {
      sender.userSignedUp()
    })
}

async function sendItemViewed(item, currencyCode) {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.itemViewed)
    .forEach(sender => {
      sender.itemViewed({ item, currencyCode })
    })
}

async function sendBookingOnGoing() {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.bookingOnGoing)
    .forEach(sender => {
      sender.bookingOnGoing()
    })
}

async function sendBookingDone() {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.bookingDone)
    .forEach(sender => {
      sender.bookingDone()
    })
}

async function sendAutoOnboardingDone() {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.autoOnboardingDone)
    .forEach(sender => {
      sender.autoOnboardingDone()
    })
}

async function sendNewLead() {
  eventSenders
    .filter(sender => sender.isAvailable() && sender.newLead)
    .forEach(sender => {
      sender.newLead()
    })
}

export default {
  sendCheckoutCompleted,
  sendBeginCheckout,
  sendProductAddedToCart,
  sendProductRemovedFromCart,
  sendUserLoggedIn,
  sendUserSignedUp,
  sendItemViewed,
  sendBookingOnGoing,
  sendBookingDone,
  sendAutoOnboardingDone,
  sendNewLead,
  load,
  reload
}
